module.exports = __webpack_public_path__ + "static/img/xcx2.f9649de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xcx2.jpg
// module id = XEDw
// module chunks = 5